module.exports = __webpack_public_path__ + "img/beer_id-41.edea698b.png";